import { CONTENT_GROUP_PARTICIPANTS } from '../constants';

const initialState = { 
    loading: false, 
    isOpenParticipantModal: false,
    content_group_id: null,
    boundary: {}
};

export function participant_popup(state = initialState, action) {
  switch (action.type) {
    case CONTENT_GROUP_PARTICIPANTS.OPEN_PARTICIPANTS_MODAL: {
        return {
            ...state,
            isOpenParticipantModal: true,
            content_group_id: action.payload.content_group_id,
            boundary: action.payload.boundary
        };
    }

    case CONTENT_GROUP_PARTICIPANTS.CLOSE_PARTICIPANTS_MODAL: {
        return {
            ...state,
            isOpenParticipantModal: false,
            content_group_id: null,
            boundary: {}
        };
    }

    default:
      return state
  }
}
